(function () {
  var DELIVERY_CHOICE_KEY = 'med7_delivery_choice';

  function getStoredChoice() {
    try { return localStorage.getItem(DELIVERY_CHOICE_KEY) || 'instant'; } catch(e) { return 'instant'; }
  }

  function saveChoice(choice) {
    try { localStorage.setItem(DELIVERY_CHOICE_KEY, choice); } catch(e) {}
  }

  function saveCartAttribute(choice) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { med7_delivery_method: choice } })
    }).catch(function() {});
  }

  // ── Flat cart attribute helpers ──────────────────────────────────────────────
  // Delivery metadata is stored as flat cart attributes per variant:
  //   line_dt_{vid}, line_lc_{vid}, line_am_{vid}
  // Falls back to item.properties for carts that existed before this migration.

  // Returns null when parsedState holds no cart data at all — distinct from [] which
  // means "cart data present, no delivery-stamped lines in it".
  //
  // parsedState is NOT always a cart. cart.js's renderAndOpenMiniCartPopup() and
  // product-form.js both write it via setParsedState() with either a sections-render blob
  // ({ sections, item_count }) or a raw /cart/add.js response — neither carries
  // `attributes`, and add.js's `items` are line items whose delivery metadata lives in
  // cart attributes, not item.properties. Reading either as "no instant lines" is what
  // made the Instant radio vanish after an add and stopped the cart-wide
  // med7_delivery_method from ever self-correcting. The absence of `attributes` is the
  // reliable tell, so gate on that and let callers re-fetch instead of guessing.
  function getLineAttrEntries(ps) {
    if (!ps || typeof ps !== 'object') return null;
    var attrs = ps.attributes;
    if (!attrs || typeof attrs !== 'object') return null;

    var entries = [];
    var seen = {};
    Object.keys(attrs).forEach(function(key) {
      var m = key.match(/^line_dt_(\d+)$/);
      if (m && !seen[m[1]]) {
        var vid = m[1];
        seen[vid] = true;
        entries.push({
          variant_id:         vid,
          delivery_type:      attrs['line_dt_' + vid] || '',
          '45_min_available': attrs['line_am_' + vid] || '0'
        });
      }
    });
    if (entries.length) return entries;

    // Fallback: synthesise entries from item.properties for legacy carts
    if (Array.isArray(ps.items)) {
      return ps.items.map(function(it) {
        return {
          variant_id:         String(it.variant_id || ''),
          delivery_type:      (it.properties && it.properties.delivery_type) || '',
          '45_min_available': (it.properties && it.properties['45_min_available']) || '0'
        };
      });
    }
    return [];
  }

  // true / false / null, where null means "cannot tell yet" (no cart data in parsedState).
  // Callers must not collapse null to false — hiding the Instant option on missing data
  // is the failure mode this tri-state exists to prevent.
  function checkInstantAvailability() {
    try {
      var ps      = JSON.parse(localStorage.getItem('parsedState') || 'null');
      var entries = getLineAttrEntries(ps);
      if (entries === null) return null;
      if (!entries.length) return false;
      return entries.some(function(e) {
        return parseInt(e['45_min_available'] || '0', 10) > 0;
      });
    } catch(e) { return null; }
  }

  function applyChoiceToUI(wrapper, choice) {
    wrapper.querySelectorAll('[data-role="method-option"]').forEach(function(opt) {
      var radio = opt.querySelector('.pdp-delivery-method__radio-input');
      if (radio) radio.checked = (opt.getAttribute('data-method') === choice);
    });
  }

  function hideLoader(wrapper) {
    var loader = wrapper.querySelector('[data-delivery-loader]');
    if (loader) loader.classList.add('cart-delivery-loader--hidden');
  }

  function showLoader(wrapper) {
    var loader = wrapper.querySelector('[data-delivery-loader]');
    if (loader) loader.classList.remove('cart-delivery-loader--hidden');
  }

  // Derives the global delivery choice from cart_line_item_attr.
  // 'instant' when any entry has 45_min_available > 0 and delivery_type = 45_minutes.
  // Falls back to reading from item.properties for legacy carts.
  function syncChoiceFromCartItems() {
    // Safety guard: if med7CartAddPrecheck's attribute write failed and the fallback
    // path is in flight, window._med7PendingAddChoice holds the intended delivery
    // choice. Skip deriving the choice from (potentially stale) cart_line_item_attr
    // so we don't overwrite localStorage back to 'nextday' before processCartDelivery
    // can commit the correct attributes.
    if (window._med7PendingAddChoice) {
      return;
    }
    try {
      var ps      = JSON.parse(localStorage.getItem('parsedState') || 'null');
      var entries = getLineAttrEntries(ps);

      // null = no cart data available (sections blob / add.js response in parsedState).
      // Deriving a choice from that would write 'nextday' over a correct 'instant'.
      if (!entries || !entries.length) return;

      // Only sync when at least one entry has a delivery_type set
      var anyStamped = entries.some(function(e) { return !!e.delivery_type; });
      if (!anyStamped) return;

      var hasInstant = entries.some(function(e) { return e.delivery_type === '45_minutes'; });
      var newChoice     = hasInstant ? 'instant' : 'nextday';
      var currentChoice = getStoredChoice();
      saveChoice(newChoice);
      if (newChoice !== currentChoice) {
        saveCartAttribute(newChoice);
      }
    } catch(e) {}
  }

  function applyAvailabilityWhenCartReady(wrapper, reason) {
    if (!document.body.contains(wrapper)) return;
    showLoader(wrapper);
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!document.body.contains(wrapper)) return;
        // Save both items AND attributes so checkInstantAvailability can read cart_line_item_attr
        try {
          var raw = localStorage.getItem('parsedState');
          var ps  = raw ? JSON.parse(raw) : {};
          ps.items      = cart.items       || [];
          ps.attributes = cart.attributes  || {};
          localStorage.setItem('parsedState', JSON.stringify(ps));
        } catch(e) {}
        syncChoiceFromCartItems();
        applyAvailability(wrapper, 'applyAvailabilityWhenCartReady fetch completed (triggered by: ' + (reason || 'unknown') + ')');
      })
      .catch(function() { applyAvailability(wrapper, 'applyAvailabilityWhenCartReady fetch error fallback (triggered by: ' + (reason || 'unknown') + ')'); });
  }

  function applyAvailability(wrapper, reason) {
    var canInstant   = checkInstantAvailability();
    // null = parsedState currently holds no cart data. Fetch the real cart rather than
    // guessing; applyAvailabilityWhenCartReady repopulates parsedState.items/.attributes
    // and calls straight back into here. The per-wrapper flag caps this at one retry so a
    // persistently unreadable cart degrades to hiding Instant instead of looping.
    if (canInstant === null) {
      if (!wrapper._med7AvailRefetched) {
        wrapper._med7AvailRefetched = true;
        applyAvailabilityWhenCartReady(wrapper, 'no cart data in parsedState (' + (reason || 'unknown') + ')');
        return;
      }
      canInstant = false;
    } else {
      wrapper._med7AvailRefetched = false;
    }
    var storedChoice = getStoredChoice();
    var instantOpt   = wrapper.querySelector('[data-method="instant"]');
    if (!canInstant) {
      if (instantOpt) instantOpt.style.display = 'none';
      applyChoiceToUI(wrapper, 'nextday');
    } else {
      if (instantOpt) instantOpt.style.display = '';
      applyChoiceToUI(wrapper, storedChoice);
    }
    hideLoader(wrapper);
  }

  // Keyed by data-delivery-context ('cart' or 'mini-cart').
  // Stores a teardown function for each widget slot so that when a cart re-render
  // creates a new wrapper DOM node and triggers a fresh initDeliveryWidget call,
  // the old anonymous-equivalent window listeners from the previous DOM generation
  // are removed before new ones are added. Without this, listeners accumulate with
  // every cart re-render (one set per re-render cycle) and events fire N times.
  var _widgetCleanups = {};

  function initDeliveryWidget(wrapper) {
    // ── Listener cleanup for this widget slot ──────────────────────────────────
    // Each cart re-render creates a fresh wrapper DOM node (no data-delivery-init)
    // which triggers initDeliveryWidget again. Clean up the previous slot's window
    // listeners before registering new ones so they don't accumulate.
    var _widgetCtx = wrapper.getAttribute('data-delivery-context') || 'unknown';
    if (_widgetCleanups[_widgetCtx]) {
      _widgetCleanups[_widgetCtx]();
      delete _widgetCleanups[_widgetCtx];
    }

    // Pre-select the radio from the Liquid-rendered cart attribute so the correct option
    // is checked before any JS reads land.
    //
    // Do NOT push this into localStorage on every init. This attribute is a snapshot of
    // cart.attributes.med7_delivery_method as of whenever Shopify rendered the section,
    // and initDeliveryWidget re-runs on every cart re-render — so a section rendered
    // moments before an attribute write lands would stamp its stale value back over the
    // fresh one. That is exactly how an add-to-cart that correctly promoted the cart to
    // 'instant' ended up back on 'nextday' a few hundred ms later. localStorage is owned
    // by med7SetDeliveryChoice / med7CartAddPrecheck / syncChoiceFromCartItems, all of
    // which write it alongside the server-side attribute. Seed it only when there is
    // nothing stored at all (genuine first visit).
    var cartAttrMethod = wrapper.getAttribute('data-delivery-method');
    if (cartAttrMethod === 'instant' || cartAttrMethod === 'nextday') {
      var hasStoredChoice = false;
      try { hasStoredChoice = !!localStorage.getItem(DELIVERY_CHOICE_KEY); } catch(e) {}
      if (!hasStoredChoice) saveChoice(cartAttrMethod);
      applyChoiceToUI(wrapper, cartAttrMethod);
    }

    function getLocationText() {
      try {
        var loc = JSON.parse(localStorage.getItem('med7_location'));
        if (loc) {
          if (loc.city && loc.country) return loc.city + ', ' + loc.country;
          if (loc.city) return loc.city;
          if (loc.address) return loc.address;
        }
      } catch (e) {}
      return 'Dubai, United Arab Emirates';
    }

    function updateLocation() {
      var el = wrapper.querySelector('[data-role="location-text"]');
      if (el) el.textContent = getLocationText();
    }

    updateLocation();

    var _locationSavedTimer = null;
    var locationSavedHandler = function() {
      updateLocation();
      showLoader(wrapper);
      if (_locationSavedTimer) clearTimeout(_locationSavedTimer);
      // Safety-net: fire only if neither med7:cart-delivery-updated nor the storage event
      // triggered applyAvailability first (covers API failures and no-change edge cases).
      _locationSavedTimer = setTimeout(function() {
        _locationSavedTimer = null;
        applyAvailabilityWhenCartReady(wrapper, 'med7:location-saved safety-net timeout');
      }, 6000);
    };
    window.addEventListener('med7:location-saved', locationSavedHandler);

    var changeBtn = wrapper.querySelector('[data-role="change-btn"]');
    if (changeBtn) {
      changeBtn.addEventListener('click', function() {
        var miniCartPopup = document.querySelector('mini-cart-popup');
        var drawerTrigger = document.getElementById('geolocation-open-drawer');
        if (miniCartPopup && typeof miniCartPopup.close === 'function' && miniCartPopup.isOpened()) {
          miniCartPopup.close();
          // Wait for fancybox close animation (200 ms) before opening the geo drawer
          setTimeout(function() {
            if (drawerTrigger) drawerTrigger.click();
          }, 280);
        } else {
          if (drawerTrigger) drawerTrigger.click();
        }
      });
    }

    wrapper.querySelectorAll('[data-role="method-option"]').forEach(function(opt) {
      opt.addEventListener('click', function() {
        var choice = opt.getAttribute('data-method');
        applyChoiceToUI(wrapper, choice);
        saveChoice(choice);
        showLoader(wrapper);

        if (typeof window.med7SetDeliveryChoice === 'function') {
          // badge JS handles /cart/update.js (both med7_delivery_method + cart_line_item_attr)
          // in one optimised flow — no separate saveCartAttribute call needed here.
          // Loader is hidden by applyAvailability → hideLoader after batchDeliveryToggle
          // → refreshCartDisplay → cartJs event → applyAvailabilityWhenCartReady completes.
          window.med7SetDeliveryChoice(choice);
        } else {
          // Fallback: badge JS not loaded (unlikely in production)
          saveCartAttribute(choice)
            .then(function() {
              hideLoader(wrapper);
              window.dispatchEvent(new CustomEvent('med7:delivery-choice-changed', { detail: { choice: choice } }));
            })
            .catch(function() {
              hideLoader(wrapper);
              window.dispatchEvent(new CustomEvent('med7:delivery-choice-changed', { detail: { choice: choice } }));
            });
        }
      });
    });

    // med7:cart-delivery-updated fires after express-delivery-badge.js saves
    // cart_line_item_attr. The event detail includes the full cart items array so
    // we can update parsedState.attributes without another /cart.js fetch.
    var deliveryUpdatedHandler = function(e) {
      var detail = (e && e.detail) || {};
      var items  = detail.items || [];
      var attrs  = detail.attributes || null;
      if (items.length || attrs) {
        try {
          var ps = JSON.parse(localStorage.getItem('parsedState') || '{}');
          if (!ps || typeof ps !== 'object') ps = {};
          if (items.length) ps.items = items;
          if (attrs) ps.attributes = attrs;
          localStorage.setItem('parsedState', JSON.stringify(ps));
        } catch(ex) {}
      }
      syncChoiceFromCartItems();
      applyAvailability(wrapper, 'med7:cart-delivery-updated event — cart attributes saved by express-delivery-badge.js');
    };
    window.addEventListener('med7:cart-delivery-updated', deliveryUpdatedHandler);

    var deliveryChoiceHandler = function(e) {
      if (e.detail && e.detail.source === 'pdp') return;
      var choice     = (e.detail && e.detail.choice) || getStoredChoice();
      var canInstant = checkInstantAvailability();
      // No cart data to judge by — leave the widget exactly as it is rather than hiding
      // an option the cart may well support.
      if (canInstant === null) return;
      var instantOpt = wrapper.querySelector('[data-method="instant"]');
      if (!canInstant) {
        if (instantOpt) instantOpt.style.display = 'none';
        applyChoiceToUI(wrapper, 'nextday');
      } else {
        if (instantOpt) instantOpt.style.display = '';
        applyChoiceToUI(wrapper, choice);
      }
    };
    window.addEventListener('med7:delivery-choice-changed', deliveryChoiceHandler);

    var storageHandler = function(e) {
      if (e.key !== 'cartJs') return;
      // Fix B: batchDeliveryToggle sets window._med7BatchToggleInFlight = true before it starts
      // and clears it in .then()/.catch(). When the toggle owns the update cycle, its
      // refreshCartDisplay fires this storage event as a side-effect — but the loader is
      // already being managed by batchDeliveryToggle (shown on click, hidden by
      // med7:cart-delivery-updated → applyAvailability). Calling applyAvailabilityWhenCartReady
      // here would show the delivery box loader a second time (~2.7 s after the first).
      if (window._med7BatchToggleInFlight) {
        return;
      }
      applyAvailabilityWhenCartReady(wrapper, 'cartJs storage event — refreshCartDisplay() fired from express-delivery-badge.js');
    };
    window.addEventListener('storage', storageHandler);

    // ── Cleanup registration ────────────────────────────────────────────────────
    // Store a teardown function keyed by this widget slot. The next initDeliveryWidget
    // call for the same slot (after a cart re-render) will invoke this before
    // registering new listeners, keeping the active listener count at exactly 1 per slot.
    _widgetCleanups[_widgetCtx] = function() {
      window.removeEventListener('med7:location-saved',       locationSavedHandler);
      window.removeEventListener('med7:cart-delivery-updated', deliveryUpdatedHandler);
      window.removeEventListener('med7:delivery-choice-changed', deliveryChoiceHandler);
      window.removeEventListener('storage',                    storageHandler);
      if (_locationSavedTimer) { clearTimeout(_locationSavedTimer); _locationSavedTimer = null; }
    };

    // On a TRUE first load parsedState is empty — fetch /cart.js to get the cart and
    // show the loader while we wait.
    // On RE-INIT after a cart re-render, parsedState is already populated by
    // refreshCartDisplay (which writes it before firing the StorageEvent). In that case
    // skip the fetch+loader entirely — call applyAvailability synchronously with the
    // data we already have. This prevents showing a second delivery-box loader every time
    // batchDeliveryToggle (or processCartDelivery) re-renders the section and creates a
    // new wrapper DOM node that triggers initDeliveryWidget again.
    (function() {
      try {
        var _initPs = JSON.parse(localStorage.getItem('parsedState') || 'null');
        // `attributes` is required, not just `items`: a /cart/add.js response also has an
        // items array, but no attributes — so it would satisfy an items-only check while
        // carrying none of the line_dt_/line_am_ data both calls below depend on.
        if (_initPs && Array.isArray(_initPs.items) && _initPs.items.length > 0 &&
            _initPs.attributes && typeof _initPs.attributes === 'object') {
          // parsedState is populated — apply immediately, no fetch, no loader.
          syncChoiceFromCartItems();
          applyAvailability(wrapper, 'initial widget load — parsedState already populated (post-render re-init), skipping fetch');
          return;
        }
      } catch(_e) { /* fall through to fetch path */ }
      // parsedState empty or missing — true first load, fetch /cart.js.
      applyAvailabilityWhenCartReady(wrapper, 'initial widget load — no parsedState, fetching cart');
    })();
  }

  function initAll() {
    var found = document.querySelectorAll(
      '[data-delivery-context="cart"]:not([data-delivery-init]),' +
      '[data-delivery-context="mini-cart"]:not([data-delivery-init])'
    );
    found.forEach(function(w) {
      w.setAttribute('data-delivery-init', '1');
      initDeliveryWidget(w);
    });
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function() {
      var found = document.querySelectorAll(
        '[data-delivery-context="cart"]:not([data-delivery-init]),' +
        '[data-delivery-context="mini-cart"]:not([data-delivery-init])'
      );
      if (found.length) {
        found.forEach(function(w) {
          w.setAttribute('data-delivery-init', '1');
          initDeliveryWidget(w);
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
